import React, { useEffect, useState } from 'react';
import { TrustRow } from './TrustRow';
import { ProductImage } from './ProductImage';
import { CHECKOUT_URL } from './constants';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) seconds--;else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 30;
          seconds = 5;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const units = [{
    value: timeLeft.hours,
    label: 'HEURES'
  }, {
    value: timeLeft.minutes,
    label: 'MIN'
  }, {
    value: timeLeft.seconds,
    label: 'SEC'
  }];
  return <section id="offre" className="py-6 px-4 sm:px-6 bg-white border-y-4 border-gold/30 scroll-mt-1" data-id="element-111" data-mp="32k2id6jj5x42">
      <div className="text-center mb-3" data-id="element-112" data-mp="37i41tskvbyg2">
        <p className="text-[11px] sm:text-sm font-heading font-bold text-cta uppercase tracking-widest mb-1" data-id="element-113" data-mp="37l9svdd25aef">
          Offre spéciale — Système complet 6-en-1
        </p>
        <h2 className="text-xl sm:text-3xl font-display text-navy leading-none mb-2" data-id="element-114" data-mp="2xrswc1ljdh72">
          Accédez dès aujourd'hui au système qui transformera votre façon de
          préparer vos séances.
        </h2>
        <ProductImage className="max-w-[200px]" data-id="element-115" data-mp="2oquot9bw2rjq" />
      </div>

      <div className="max-w-md mx-auto bg-cream border-2 border-gold rounded-xl p-4 sm:p-5 text-center mb-3 shadow-lg" data-id="element-116" data-mp="29wq4rlvckzmw">
        <p className="font-display text-xl sm:text-2xl text-navy tracking-wide leading-none mb-1" data-id="element-117" data-mp="2ev9rhohrmfgb">
          SENIOR FITNESS PRO™
        </p>
        <p className="font-heading font-semibold text-navy text-[11px] sm:text-xs leading-snug mb-2" data-id="element-118" data-mp="d3eodx9krj9p">
          Le Système Complet de Planification 6-en-1 pour les Professionnels du
          Fitness Senior
        </p>

        <ul className="text-[12.5px] sm:text-sm font-semibold text-ink mb-2 space-y-0.5" data-id="element-119" data-mp="6mldxyq7qegv">
          <li data-id="element-120" data-mp="1ni9ogi24c9y">✅ 6 Modules Professionnels</li>
          <li data-id="element-121" data-mp="1ojvng0m2j6g">✅ 5 Bonus Premium</li>
        </ul>

        <p className="text-[13px] font-semibold text-ink mb-0.5" data-id="element-122" data-mp="3ts41gpfbio64">
          Prix habituel : <span className="line-through" data-id="element-123" data-mp="ucpjibmyooai">97 €</span>
        </p>
        <p className="text-[11px] sm:text-sm font-heading font-bold text-cta mb-0.5 uppercase tracking-wide" data-id="element-124" data-mp="uc7futxyz7sk">
          🔥 Offre de lancement — 72 % de réduction
        </p>
        <p className="text-3xl sm:text-4xl font-display text-navy leading-none mb-0.5" data-id="element-125" data-mp="kluke6om9u7n">
          Aujourd'hui seulement : 27 €
        </p>
        <p className="text-[10px] font-semibold text-ink uppercase tracking-widest mb-3" data-id="element-126" data-mp="gj80cry6tdl0">
          Payez en toute sécurité dans votre devise locale.
        </p>

        <div className="bg-white border border-gold/40 rounded-lg p-2.5 mb-3" data-id="element-127" data-mp="18bfffny1ohxa">
          <p className="text-[11px] font-heading font-bold text-cta mb-1.5 uppercase tracking-wide" data-id="element-128" data-mp="2qzrr8xzqrr8p">
            🔥 Cette offre disparaîtra lorsque le compteur atteindra zéro.
          </p>
          <div className="flex justify-center gap-2" data-id="element-129" data-mp="3006ew406hifd">
            {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-130" data-mp="34yrhub6teg7i" data-mpi={i}>
                {i > 0 && <span className="text-xl font-bold text-navy" data-id="element-131" data-mp="350axbzkncn88">:</span>}
                <div className="text-center" data-id="element-132" data-mp="39x1ekq86tov8">
                  <div className="bg-navy text-white text-xl font-display px-2.5 py-1.5 rounded min-w-[48px] leading-none" data-id="element-133" data-mp="39w9ry4wkj1h3">
                    {String(unit.value).padStart(2, '0')}
                  </div>
                  <p className="text-[9px] font-bold text-navy/70 mt-0.5 tracking-widest" data-id="element-134" data-mp="3jq9vw3g460o8">
                    {unit.label}
                  </p>
                </div>
              </React.Fragment>)}
          </div>
        </div>

        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block w-full text-center cursor-pointer px-3 py-3 sm:py-3.5 font-heading font-extrabold text-[13px] sm:text-base uppercase tracking-wide rounded-lg bg-cta text-white hover:bg-cta-dark transition-colors duration-200 border-b-4 border-[#A85510] active:border-b-0 active:translate-y-1 shadow-[0_4px_14px_0_rgba(230,126,34,0.4)]" data-id="element-135" data-mp="1jca5glwsipj">
          🚀 OUI ! JE VEUX MON SYSTÈME COMPLET 6-EN-1
        </a>
      </div>

      <TrustRow data-id="element-136" data-mp="312c6t2sucm4f" />
    </section>;
}